import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const DOCUMENT_CONFIG_URL = `${API_BASE_URL}/DocumentConfigurationSaas`;

export const getPagedDocuments = async (
  page = 1,
  pageSize = 10,
  search = '',
  ascending = true,
  sortBy = null,
  desc = null
) => {
  try {
    const params = {
      page,
      pageSize,
    };

    if (search && search.trim()) {
      params.search = search.trim();
    }

    if (sortBy) {
      params.sortBy = sortBy;
    }

    if (desc !== null && desc !== undefined) {
      params.desc = desc;
    } else {
      params.desc = !ascending;
    }

    const response = await api.get(DOCUMENT_CONFIG_URL, { params });

    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching documents:', error);
    throw error;
  }
};

export const createDocument = async (payload) => {
  try {
    const response = await api.post(DOCUMENT_CONFIG_URL, {
      name: payload.name,
      serviceId: payload.serviceId,
      businessAreaId: payload.businessAreaId,
      deliveryTypeId: payload.deliveryTypeId || 1,
      documentGroupId: payload.documentGroupId || null,
      documentTypeId: payload.documentTypeId || null,
      content: payload.content,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating document:', error);
    throw error;
  }
};

export const getDocumentForEdit = async (id) => {
  try {
    const response = await api.get(`${DOCUMENT_CONFIG_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching document for edit:', error);
    throw error;
  }
};

export const updateDocument = async (id, payload) => {
  try {
    const response = await api.put(`${DOCUMENT_CONFIG_URL}/${id}`, {
      name: payload.name,
      serviceId: payload.serviceId,
      businessAreaId: payload.businessAreaId,
      deliveryTypeId: payload.deliveryTypeId || 1,
      documentGroupId: payload.documentGroupId || null,
      documentTypeId: payload.documentTypeId || null,
      content: payload.content,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating document:', error);
    throw error;
  }
};

export const getRelatedData = async () => {
  try {
    const response = await api.get(`${DOCUMENT_CONFIG_URL}/related-data`);

    // Asegurar que deliveryType es un array
    let deliveryType = response.data.deliveryType || [];

    // Si viene como string JSON, parsear
    if (typeof deliveryType === 'string') {
      try {
        deliveryType = JSON.parse(deliveryType);
      } catch (e) {
        console.error('No se pudo parsear deliveryType como JSON');
        deliveryType = [];
      }
    }

    // Asegurar que es un array
    if (!Array.isArray(deliveryType)) {
      console.error(
        'deliveryType no es un array después de procesar:',
        deliveryType
      );
      deliveryType = [];
    }

    // Transformar a formato { value, label }
    const transformedDeliveryType = deliveryType.map((item) => ({
      value: item.id,
      label: item.name,
    }));

    // Procesar documentGroups para Grupo Escrito
    let documentGroups = response.data.documentGroups || [];

    if (!Array.isArray(documentGroups)) {
      documentGroups = [];
    }

    const transformedDocumentGroups = documentGroups.map((item) => ({
      value: item.id,
      label: item.descripcion,
    }));

    return {
      ...response.data,
      deliveryType: transformedDeliveryType,
      documentGroups: transformedDocumentGroups,
    };
  } catch (error) {
    console.error('Error en getRelatedData:', error);
    throw error;
  }
};

export const convertDocumentToHtml = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(
      `${DOCUMENT_CONFIG_URL}/convert`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data.html;
  } catch (error) {
    console.error('Error converting document:', error);
    throw error;
  }
};

export const deleteDocument = async (id) => {
  try {
    const response = await api.delete(`${DOCUMENT_CONFIG_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

export const getDocumentTypesByGroupId = async (documentGroupId) => {
  if (!documentGroupId) return [];

  try {
    const response = await api.get(
      `${DOCUMENT_CONFIG_URL}/document-types/${encodeURIComponent(documentGroupId)}`
    );

    const rawData = Array.isArray(response.data)
      ? response.data
      : Array.isArray(response.data?.data)
        ? response.data.data
        : [];

    return rawData.map((item) => ({
      value: item.id,
      label: item.descripcion || item.description || item.name || '',
    }));
  } catch (error) {
    console.error('Error fetching document types:', error);
    throw error;
  }
};
